// union is not implemented by JavaScript sets
/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
export function union(setA: Set<any>, setB: Set<any>) {
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  const set: Set<any> = new Set(setA);
  setB.forEach(elem => {
    set.add(elem);
  });

  return set;
}
